import { Provider } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes, useLocation, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AppModule from "./features/AppModule/AppModule";
import AssetsRegistration from "./features/AssetsManagement/AssetsRegistration";
import CreateEquipment from "./features/AssetsManagement/Equipments/CreateEquipment";
import AssetsEquipmentDetails from "./features/AssetsManagement/Equipments/EquipmentDetails";
import CreateTyre from "./features/AssetsManagement/Tyres/CreateTyre";
import AssetsTyreDetails from "./features/AssetsManagement/Tyres/TyreDetails";
import Create3PLVehicle from "./features/AssetsManagement/Vehicles/Create3PLVehicle";
import CreateHiredVehicle from './features/AssetsManagement/Vehicles/CreateHiredVehicle';
import CreatePurchasedVehicle from './features/AssetsManagement/Vehicles/CreatePurchasedVehicle';
import AssetsVehicleDetails from "./features/AssetsManagement/Vehicles/VehicleDetails";
import ContractDetails from "./features/Contracts/ContractDetails";
import Contracts from "./features/Contracts/Contracts";
import CreateContract from "./features/Contracts/CreateContract";
import AddCustomer from "./features/Customers/AddCustomer";
import CustomerDetails from "./features/Customers/CustomerDetails";
import Customers from "./features/Customers/Customers";
import FMCR from "./features/FMCR/FMCR";
import GenerateReport from "./features/FMCR/GenerateReport";
import ReportDetails from "./features/FMCR/ReportDetails";
import VehicleStatus from "./features/FMCR/VehicleStatus";
import VehicleTracking from "./features/FMCR/VehicleTracking/VehicleTracking";
import FinanceDashboard from "./features/Finance/Dashboard/FinanceDashboard";
import DriverExpense from "./features/Finance/DriverExpense/DriverExpense";
import DriverExpenseDetails from "./features/Finance/DriverExpense/DriverExpenseDetails";
import DriverPaymentDetails from "./features/Finance/DriverPayments/DriverPaymentDetails";
import DriverPayments from "./features/Finance/DriverPayments/DriverPayments";
import CreateInvoice from "./features/Finance/Invoices/CreateInvoice";
import InvoiceDetails from "./features/Finance/Invoices/InvoiceDetails";
import Invoices from "./features/Finance/Invoices/Invoices";
import CreatePayrollRun from "./features/Finance/Payroll/CreatePayrollRun";
import Payroll from "./features/Finance/Payroll/Payroll";
import PayrollDetails from "./features/Finance/Payroll/PayrollDetails";
import RunSalaryCalculation from "./features/Finance/Payroll/RunSalaryCalculation";
import FinanceReports from "./features/Finance/Reports/FinanceReports";
import FinancialReportDetails from "./features/Finance/Reports/FinancialReportDetails";
import FinancialReports from "./features/Finance/Reports/FinancialReports";
import FinanceSettings from "./features/Finance/Settings/FinanceSettings";
import CreateTripCostEstimation from "./features/Finance/TripCostEstimation/CreateTripCostEstimation";
import TripCostEstimation from "./features/Finance/TripCostEstimation/TripCostEstimation";
import TripCostEstimationDetails from "./features/Finance/TripCostEstimation/TripCostEstimationDetails";
import Fuel from "./features/Fuel/Fuel";
import FuelDetails from "./features/Fuel/FuelDetails";
import FuelStationCreate from "./features/Fuel/FuelStations/FuelStationCreate";
import FuelStationDetails from "./features/Fuel/FuelStations/FuelStationDetails";
import FuelStations from "./features/Fuel/FuelStations/FuelStations";
import VehicleDetails from "./features/Fuel/VehicleDetails";
import PartCreate from "./features/Inventory/Parts/PartCreate";
import PartDetails from "./features/Inventory/Parts/PartDetails";
import Parts from "./features/Inventory/Parts/Parts";
import AddNewRFQ from "./features/Inventory/Procurement/AddNewRFQ";
import PODetails from "./features/Inventory/Procurement/PODetails";
import Procurement from "./features/Inventory/Procurement/Precurement";
import RFQDetails from "./features/Inventory/Procurement/RFQDetails";
import VendorAndWarehouse from "./features/Inventory/VendorAndWarehouse/VendorAndWarehouse";
import VendorDetails from "./features/Inventory/VendorAndWarehouse/VendorDetails";
import WarehouseDetails from "./features/Inventory/VendorAndWarehouse/WarehouseDetails";
import IssueDetails from "./features/Issues/IssueDetails";
import Issues from "./features/Issues/Issues";
import Access from "./features/Maintenance/Access";
import Categories from "./features/Maintenance/Categories/Categories";
import PartMakes from "./features/Maintenance/PartMakes/PartMakes";
import PartModels from "./features/Maintenance/PartModels/PartModels";
import VehicleType from "./features/Maintenance/VehicleType/VehicleType";
import AddDriver from "./features/Operations/AddDriver";
import AttendanceLogs from "./features/Operations/AttendanceLogs";
import DriverDetails from "./features/Operations/DriverDetails";
import DriverSafety from "./features/Operations/DriverSafety";
import Roles from "./features/Roles/Roles";
import RoleManagement from "./features/RoleManagement/RoleManagement";
import EditServiceEntry from "./features/ServiceEntry/EditServiceEntry";
import ServiceEntry from "./features/ServiceEntry/ServiceEntry";
import Services from "./features/ServiceEntry/Services";
import TripCreate from "./features/Trip/Create";
import TripDetails from "./features/Trip/TripDetails";
import Trips from "./features/Trip/Trips";
import TripsList from "./features/Trip/TripsList/TripsList";
import TripPlanningDetails from "./features/Trip/TripPlanningDetails";
import TripLoadingDispatch from "./features/Trip/TripLoadingDispatch";
import TripReadyDispatch from "./features/Trip/TripReadyDispatch";
import TripInTransit from "./features/Trip/TripInTransit";
import TripCompleted from "./features/Trip/TripCompleted";
import TripClosingActivity from "./features/Trip/TripClosingActivity";
import FuelRequests from "./features/Trip/FuelRequests";
import PettyCash from "./features/Trip/PettyCash";
import TripExpense from "./features/Trip/TripExpense";
import WordOrderDetails from "./features/WorkOrders/WordOrderDetails";
import WorkOrders from "./features/WorkOrders/WorkOrders";
import DriverTraining from "./features/TrainingLibrary/DriverTraining";
import FMSTraining from "./features/TrainingLibrary/FMSTraining";
import FMSDocumentation from "./features/TrainingLibrary/FMSDocumentation";
import MainLayout from "./layouts/mainLayout";
import DataDashboard from "./pages/DataDashboard";
import DefaultPassword from "./pages/DefaultPassword";
import ForgotPassword from "./pages/ForgotPassword";
import Login from "./pages/Login";
import Maintenance from "./pages/Maintenance";
import NotFound from "./pages/NotFound";
import RFQ from "./pages/RFQ-Request";
import ResetPassword from "./pages/ResetPassword";
import Settings from "./pages/Settings";
import Test from "./pages/Test";
import AddLoadBooking from "./pages/ThreePL/AddLoadBooking";
import AddTransporter from "./pages/ThreePL/AddTransporter";
import LoadBooking from "./pages/ThreePL/LoadBooking";
import Quotations from "./pages/ThreePL/Quotations";
import Transporters from "./pages/ThreePL/Transporters";
import TransporterByLoad from "./pages/TransporterByLoad";
import Tyre from "./pages/Tyre";
import { store } from "./store";
import FullProtectedRoutes from "./utils/FullProtectedRoutes";
import ProtectedRoute from "./utils/ProtectedRoutes";
import { SocketProvider } from "./utils/SocketContext";
import { TripSocketProvider } from "./utils/SocketTripContext";
import {
  AppMainModules,
  AssetsPermission,
  AssetsSubModules,
  CategoriesPermission,
  CustomersPermission,
  CustomersSubModules,
  DashboardPermission,
  DriverSafetyPermission,
  FinancePermission,
  FinanceSubModules,
  FMCRPermission,
  FMCRSubModules,
  ContractPermission,
  ReportsPermission,
  FuelPermission,
  FuelStationPermission,
  FuelSubModules,
  InventorySubModules,
  IssuePermission,
  MaintinaceSubModules,
  OperationsSubModules,
  PartMakesPermission,
  PartModelsPermission,
  PartsPermission,
  ProcurementPermission,
  ServicesPermission,
  TripPermission,
  TripSubModules,
  VehicleTypePermission,
  VendorAndWarehousePermission,
  WorkOrdersPermission,
} from "./utils/app-constant";

const ThreePLCustomerDetailsRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/customers/details/${id}`} replace />;
};

const ThreePLTransporterDetailsRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/transporters/details/${id}`} replace />;
};

const LegacyAssetsRegistrationRedirect = () => {
  const location = useLocation();
  const pathname = location.pathname.replace(
    /^\/assets-registration(?=\/|$)/,
    "/assets"
  );

  return <Navigate to={`${pathname}${location.search}${location.hash}`} replace />;
};

const LegacyFinanceTripCostEstimationRedirect = () => {
  const location = useLocation();
  const pathname = location.pathname.replace(
    /^\/finance\/trip-cost-estimation(?=\/|$)/,
    "/trip-cost-estimation"
  );

  return <Navigate to={`${pathname}${location.search}${location.hash}`} replace />;
};

const LegacyFinanceExpensesRedirect = () => {
  const location = useLocation();
  const pathname = location.pathname.replace(
    /^\/finance\/expenses(?=\/|$)/,
    "/expenses"
  );

  return <Navigate to={`${pathname}${location.search}${location.hash}`} replace />;
};

const LegacyFinanceDriverPaymentsRedirect = () => {
  const location = useLocation();
  const pathname = location.pathname.replace(
    /^\/finance\/driver-payments(?=\/|$)/,
    "/driver-payments"
  );

  return <Navigate to={`${pathname}${location.search}${location.hash}`} replace />;
};

const LegacyFinancePricingTemplatesRedirect = () => {
  const location = useLocation();
  const pathname = location.pathname.replace(
    /^\/finance\/pricing-templates(?=\/|$)/,
    "/contract"
  );

  return <Navigate to={`${pathname}${location.search}${location.hash}`} replace />;
};

const LegacyPricingTemplatesRedirect = () => {
  const location = useLocation();
  const pathname = location.pathname.replace(
    /^\/pricing-templates(?=\/|$)/,
    "/contract"
  );

  return <Navigate to={`${pathname}${location.search}${location.hash}`} replace />;
};

const LegacyFinanceInvoicesRedirect = () => {
  const location = useLocation();
  const pathname = location.pathname.replace(
    /^\/finance\/invoices(?=\/|$)/,
    "/invoices"
  );

  return <Navigate to={`${pathname}${location.search}${location.hash}`} replace />;
};

const LegacyFinanceFinancialReportsRedirect = () => {
  const location = useLocation();
  const pathname = location.pathname.replace(
    /^\/finance\/financial-reports(?=\/|$)/,
    "/financial-reports"
  );

  return <Navigate to={`${pathname}${location.search}${location.hash}`} replace />;
};

const App = () => {
  return (
    <TripSocketProvider>
      <SocketProvider>
        <Provider store={store}>
          <BrowserRouter>
            <ToastContainer
              position="top-center"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />

            <Routes>
              <Route path="/rfq-request" element={<RFQ />} />
              <Route path="/transporter-by-load" element={<TransporterByLoad />} />
              <Route path="/" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                path="/change-default-password"
                element={<DefaultPassword />}
              />
              <Route path="/no-access" element={<NotFound />} />

              <Route
                path="/app-modules"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<AppModule />} />
              </Route>

              <Route
                path="/roles"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Roles />} />
              </Route>

              <Route
                path="/training-library"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Navigate to="/training-library/driver-training" replace />} />
                <Route path="driver-training" element={<DriverTraining />} />
                <Route path="fms-training" element={<FMSTraining />} />
                <Route path="fms-documentation" element={<FMSDocumentation />} />
              </Route>

              <Route
                path="/role-management"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<RoleManagement />} />
              </Route>

              <Route
                path="/vendor-&-warehouse"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<VendorAndWarehouse />} />
              </Route>

              <Route
                path="/assets"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.assetsManagement}
                      subModule={AssetsSubModules.Assets}
                      permission={[
                        AssetsPermission.ViewVehicle,
                        AssetsPermission.ViewEquipment,
                        AssetsPermission.ViewTyre,
                      ]}
                    >
                      <AssetsRegistration />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="create-purchased-vehicle"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.assetsManagement}
                      subModule={AssetsSubModules.Assets}
                      permission={AssetsPermission.CreateVehicle}
                    >
                      <CreatePurchasedVehicle />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="create-hired-vehicle"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.assetsManagement}
                      subModule={AssetsSubModules.Assets}
                      permission={AssetsPermission.CreateVehicle}
                    >
                      <CreateHiredVehicle />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="create-3pl-vehicle"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.assetsManagement}
                      subModule={AssetsSubModules.Assets}
                      permission={AssetsPermission.CreateVehicle}
                    >
                      <Create3PLVehicle />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="create-equipment"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.assetsManagement}
                      subModule={AssetsSubModules.Assets}
                      permission={AssetsPermission.CreateEquipment}
                    >
                      <CreateEquipment />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="create-tyre"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.assetsManagement}
                      subModule={AssetsSubModules.Assets}
                      permission={AssetsPermission.CreateTyre}
                    >
                      <CreateTyre />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="vehicles/:systemId"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.assetsManagement}
                      subModule={AssetsSubModules.Assets}
                      permission={AssetsPermission.ViewVehicle}
                    >
                      <AssetsVehicleDetails />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="equipments/:systemId"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.assetsManagement}
                      subModule={AssetsSubModules.Assets}
                      permission={AssetsPermission.ViewEquipment}
                    >
                      <AssetsEquipmentDetails />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="tyres/:systemId"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.assetsManagement}
                      subModule={AssetsSubModules.Assets}
                      permission={AssetsPermission.ViewTyre}
                    >
                      <AssetsTyreDetails />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/assets-registration/*"
                element={<LegacyAssetsRegistrationRedirect />}
              />

              <Route
                path="/transporters"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Transporters />} />
                <Route path="add" element={<AddTransporter />} />
                <Route path="details/:id" element={<AddTransporter />} />
              </Route>

              <Route
                path="/customers"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.customers}
                      subModule={CustomersSubModules.Customers}
                      permission={CustomersPermission.View}
                    >
                      <Customers />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="add"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.customers}
                      subModule={CustomersSubModules.Customers}
                      permission={CustomersPermission.Create}
                    >
                      <AddCustomer />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="details/:id"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.customers}
                      subModule={CustomersSubModules.Customers}
                      permission={CustomersPermission.View}
                    >
                      <CustomerDetails />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/trip-cost-estimation"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.TripCostEstimation}
                      permission={FinancePermission.View}
                    >
                      <TripCostEstimation />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/trip-cost-estimation/create"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.TripCostEstimation}
                      permission={FinancePermission.Create}
                    >
                      <CreateTripCostEstimation />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/trip-cost-estimation/:id"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.TripCostEstimation}
                      permission={FinancePermission.View}
                    >
                      <TripCostEstimationDetails />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/finance/trip-cost-estimation/*"
                element={<LegacyFinanceTripCostEstimationRedirect />}
              />

              <Route
                path="/expenses"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.DriverExpense}
                      permission={FinancePermission.View}
                    >
                      <DriverExpense />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="trip-expense/:id"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.DriverExpense}
                      permission={FinancePermission.View}
                    >
                      <DriverExpenseDetails />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/finance/expenses/*"
                element={<LegacyFinanceExpensesRedirect />}
              />

              <Route
                path="/driver-payments"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.DriverPayments}
                      permission={FinancePermission.View}
                    >
                      <DriverPayments />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/driver-payments/create"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.DriverPayments}
                      permission={FinancePermission.Create}
                    >
                      <RunSalaryCalculation />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/driver-payments/:id"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.DriverPayments}
                      permission={FinancePermission.View}
                    >
                      <DriverPaymentDetails />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/finance/driver-payments/*"
                element={<LegacyFinanceDriverPaymentsRedirect />}
              />

              <Route
                path="/payroll"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.Payroll}
                      permission={FinancePermission.View}
                    >
                      <Payroll />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/payroll/create"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.Payroll}
                      permission={FinancePermission.Create}
                    >
                      <CreatePayrollRun />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/payroll/:id"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.Payroll}
                      permission={FinancePermission.View}
                    >
                      <PayrollDetails />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/contract"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.contract}
                      subModule="contract"
                      permission={ContractPermission.View}
                    >
                      <Contracts />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/contract/create"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.contract}
                      subModule="contract"
                      permission={ContractPermission.Create}
                    >
                      <CreateContract />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/contract/:id"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.contract}
                      subModule="contract"
                      permission={ContractPermission.View}
                    >
                      <ContractDetails />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/pricing-templates/*"
                element={<LegacyPricingTemplatesRedirect />}
              />

              <Route
                path="/finance/pricing-templates/*"
                element={<LegacyFinancePricingTemplatesRedirect />}
              />

              <Route
                path="/finance-dashboard"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.Dashboard}
                      permission={FinancePermission.View}
                    >
                      <FinanceDashboard />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/invoices"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.Invoices}
                      permission={FinancePermission.View}
                    >
                      <Invoices />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/invoices/create"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.Invoices}
                      permission={FinancePermission.Create}
                    >
                      <CreateInvoice />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/invoices/create-single-trip"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.Invoices}
                      permission={FinancePermission.Create}
                    >
                      <CreateInvoice />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/invoices/create-bulk"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.Invoices}
                      permission={FinancePermission.Create}
                    >
                      <CreateInvoice />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/invoices/details/:id"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.Invoices}
                      permission={FinancePermission.View}
                    >
                      <InvoiceDetails />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/invoices/bulk/:id"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.Invoices}
                      permission={FinancePermission.View}
                    >
                      <InvoiceDetails />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/invoices/:id"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.Invoices}
                      permission={FinancePermission.View}
                    >
                      <InvoiceDetails />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/finance/invoices/*"
                element={<LegacyFinanceInvoicesRedirect />}
              />

              <Route
                path="/financial-reports"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.Reports}
                      permission={[ReportsPermission.ViewPnl, ReportsPermission.ViewAr]}
                    >
                      <FinancialReports />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/finance-reports"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.Reports}
                      permission={[ReportsPermission.ViewPnl, ReportsPermission.ViewAr]}
                    >
                      <FinanceReports />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="details/:id"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.Reports}
                      permission={[ReportsPermission.ViewPnl, ReportsPermission.ViewAr]}
                    >
                      <FinancialReportDetails />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/finance/financial-reports/*"
                element={<LegacyFinanceFinancialReportsRedirect />}
              />

              <Route
                path="/finance-settings"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.finance}
                      subModule={FinanceSubModules.Settings}
                      permission={["view-taxrule", "view-approval-workflow", "view-invoice-columns"]}
                    >
                      <FinanceSettings />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/3pl"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  path="transporter"
                  element={<Navigate to="/transporters" replace />}
                />
                <Route
                  path="transporter/add"
                  element={<Navigate to="/transporters/add" replace />}
                />
                <Route
                  path="transporter/details/:id"
                  element={<ThreePLTransporterDetailsRedirect />}
                />
                <Route
                  path="customers"
                  element={<Navigate to="/customers" replace />}
                />
                <Route
                  path="customers/add"
                  element={<Navigate to="/customers/add" replace />}
                />
                <Route
                  path="customers/details/:id"
                  element={<ThreePLCustomerDetailsRedirect />}
                />
                <Route path="load-booking" element={<LoadBooking />} />
                <Route path="load-booking/create" element={<AddLoadBooking />} />
                <Route path="load-booking/details/:id" element={<AddLoadBooking />} />
                <Route path="quotations" element={<Quotations />} />
              </Route>

              <Route
                path="/vendor"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.inventoryManagement}
                    subModule={InventorySubModules.Vendor}
                    permission={VendorAndWarehousePermission.ViewVendor}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<VendorAndWarehouse />} />
              </Route>

              <Route
                path="/warehouse"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.inventoryManagement}
                    subModule={InventorySubModules.Warehouse}
                    permission={VendorAndWarehousePermission.ViewWarehouse}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<VendorAndWarehouse />} />
              </Route>

              <Route
                path="/vendor/:id"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.inventoryManagement}
                    subModule={InventorySubModules.Vendor}
                    permission={VendorAndWarehousePermission.ViewVendor}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<VendorDetails />} />
              </Route>

              <Route
                path="/warehouse/:id"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.inventoryManagement}
                    subModule={InventorySubModules.Warehouse}
                    permission={VendorAndWarehousePermission.ViewWarehouse}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<WarehouseDetails />} />
              </Route>

              <Route
                path="/driver-safety"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.operations}
                      subModule={OperationsSubModules.DriverSafety}
                      permission={DriverSafetyPermission.View}
                    >
                      <DriverSafety />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/driver-safety/attendance-logs"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.operations}
                      subModule={OperationsSubModules.DriverSafety}
                      permission={DriverSafetyPermission.View}
                    >
                      <AttendanceLogs />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/driver-safety/add"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.operations}
                      subModule={OperationsSubModules.DriverSafety}
                      permission={DriverSafetyPermission.Create}
                    >
                      <AddDriver />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/driver-safety/details/:id"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.operations}
                      subModule={OperationsSubModules.DriverSafety}
                      permission={DriverSafetyPermission.View}
                    >
                      <DriverDetails />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/parts"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.inventoryManagement}
                    subModule={InventorySubModules.Parts}
                    permission={PartsPermission.View}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<Parts />} />
              </Route>

              <Route
                path="/procurement"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.inventoryManagement}
                    subModule={InventorySubModules.Procurement}
                    permission={[
                      ProcurementPermission.ViewRfq,
                      ProcurementPermission.ViewPo,
                    ]}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<Procurement />} />
              </Route>

              <Route
                path="/rfqs/create"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.inventoryManagement}
                    subModule={InventorySubModules.Procurement}
                    permission={ProcurementPermission.CreateRfq}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<AddNewRFQ />} />
              </Route>

              <Route
                path="/rfqs/details/:id"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.inventoryManagement}
                    subModule={InventorySubModules.Procurement}
                    permission={ProcurementPermission.ViewRfq}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<RFQDetails />} />
              </Route>

              <Route
                path="/po/details/:id"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.inventoryManagement}
                    subModule={InventorySubModules.Procurement}
                    permission={ProcurementPermission.ViewPo}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<PODetails />} />
              </Route>

              <Route
                path="/parts/create"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.inventoryManagement}
                    subModule={InventorySubModules.Parts}
                    permission={PartsPermission.Create}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<PartCreate />} />
              </Route>

              <Route
                path="/parts/details/:id"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.inventoryManagement}
                    subModule={InventorySubModules.Parts}
                    permission={PartsPermission.View}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<PartDetails />} />
              </Route>

              <Route
                path="/settings"
                element={
                  <ProtectedRoute permission="any">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Settings />} />
              </Route>

              <Route
                path="/dashboard"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.maintenance}
                    subModule={MaintinaceSubModules.Dashboard}
                    permission={DashboardPermission.View}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<DataDashboard />} />
              </Route>

              <Route
                path="/services"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.maintenance}
                    subModule={MaintinaceSubModules.Services}
                    permission={ServicesPermission.View}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<Services />} />
              </Route>

              <Route
                path="/services/service-entry"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.maintenance}
                    subModule={MaintinaceSubModules.Services}
                    permission={ServicesPermission.Create}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<ServiceEntry />} />
              </Route>

              <Route
                path="/services/edit-service-entry/:id"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.maintenance}
                    subModule={MaintinaceSubModules.Services}
                    permission={ServicesPermission.View} // Or Create/Update depending on intent, usually View + component internal check for Update
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<EditServiceEntry />} />
              </Route>

              <Route
                path="/work-orders"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.maintenance}
                    subModule={MaintinaceSubModules.WorkOrders}
                    permission={WorkOrdersPermission.View}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<WorkOrders />} />
              </Route>

              <Route
                path="/work-orders/work-order-details/:id"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.maintenance}
                    subModule={MaintinaceSubModules.WorkOrders}
                    permission={WorkOrdersPermission.View}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<WordOrderDetails />} />
              </Route>

              <Route
                path="/issue"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.maintenance}
                    subModule={MaintinaceSubModules.Issue}
                    permission={IssuePermission.View}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<Issues />} />
              </Route>

              <Route
                path="/issue/issue-details/:id"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.maintenance}
                    subModule={MaintinaceSubModules.Issue}
                    permission={IssuePermission.View}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<IssueDetails />} />
              </Route>

              <Route
                path="/categories"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.maintenance}
                    subModule={MaintinaceSubModules.Categories}
                    permission={CategoriesPermission.View}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<Categories />} />
              </Route>

              <Route
                path="/vehicle-type"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.maintenance}
                    subModule={MaintinaceSubModules.VehicleType}
                    permission={VehicleTypePermission.View}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<VehicleType />} />
              </Route>

              <Route
                path="/part-models"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.maintenance}
                    subModule={MaintinaceSubModules.PartModels}
                    permission={PartModelsPermission.View}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<PartModels />} />
              </Route>

              <Route
                path="/part-makes"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.maintenance}
                    subModule={MaintinaceSubModules.PartMakes}
                    permission={PartMakesPermission.View}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<PartMakes />} />
              </Route>

              <Route
                path="/access-management"
                element={
                  <ProtectedRoute permission="view">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Access />} />
              </Route>

              <Route
                path="/maintenance"
                element={
                  <ProtectedRoute permission="view">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Maintenance />} />
              </Route>

              <Route
                path="/tyre"
                element={
                  <ProtectedRoute permission="view">
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Tyre />} />
              </Route>

              <Route
                path="/trips"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.tripManagement}
                    subModule={TripSubModules.Trips}
                    permission="any"
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<Trips />} />
              </Route>

              <Route
                path="/trips/create"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.tripManagement}
                    subModule={TripSubModules.Trips}
                    permission={TripPermission.Create}
                  >
                    <Navigate to="/trips?create=true" replace />
                  </FullProtectedRoutes>
                }
              />

              <Route
                path="/trips/:id"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.tripManagement}
                    subModule={TripSubModules.Trips}
                    permission="any"
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<TripDetails />} />
              </Route>

              <Route
                path="/trips/planning/:id"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.tripManagement}
                    subModule={TripSubModules.TripsList}
                    permission="any"
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<TripPlanningDetails />} />
              </Route>

              <Route
                path="/trips/fuel-requests"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.fuelManagement}
                    subModule={FuelSubModules.FuelRequests}
                    fallbackMainModule={AppMainModules.tripManagement}
                    fallbackSubModule={TripSubModules.FuelRequests}
                    permission="any"
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<FuelRequests />} />
              </Route>

              <Route
                path="/fuel-requests"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.fuelManagement}
                    subModule={FuelSubModules.FuelRequests}
                    fallbackMainModule={AppMainModules.tripManagement}
                    fallbackSubModule={TripSubModules.FuelRequests}
                    permission="any"
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<FuelRequests />} />
              </Route>

              <Route
                path="/trips/petty-cash"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.tripManagement}
                    subModule={TripSubModules.PettyCash}
                    permission="any"
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<PettyCash />} />
              </Route>

              <Route
                path="/petty-cash"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.tripManagement}
                    subModule={TripSubModules.PettyCash}
                    permission="any"
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<PettyCash />} />
              </Route>

              <Route
                path="/trips/expenses"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.tripManagement}
                    subModule={TripSubModules.TripExpense}
                    permission="any"
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<TripExpense />} />
              </Route>

              <Route
                path="/trip-expenses"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.tripManagement}
                    subModule={TripSubModules.TripExpense}
                    permission="any"
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<TripExpense />} />
              </Route>

              <Route
                path="/trips-list"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.tripManagement}
                    subModule={TripSubModules.TripsList}
                    permission="any"
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<TripsList />} />
                <Route
                  path="planning/:id"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.tripManagement}
                      subModule={TripSubModules.TripsList}
                      permission="any"
                    >
                      <TripPlanningDetails />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="loading-dispatch/:id"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.tripManagement}
                      subModule={TripSubModules.TripsList}
                      permission="any"
                    >
                      <TripLoadingDispatch />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="ready-dispatch/:id"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.tripManagement}
                      subModule={TripSubModules.TripsList}
                      permission="any"
                    >
                      <TripReadyDispatch />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="in-transit/:id"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.tripManagement}
                      subModule={TripSubModules.TripsList}
                      permission="any"
                    >
                      <TripInTransit />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="completed/:id"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.tripManagement}
                      subModule={TripSubModules.TripsList}
                      permission="any"
                    >
                      <TripCompleted />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="trip-completed/:id"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.tripManagement}
                      subModule={TripSubModules.TripsList}
                      permission="any"
                    >
                      <TripClosingActivity />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              <Route
                path="/fmcr"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.fmcr}
                    subModule={FMCRSubModules.FMCR}
                    permission={[
                      FMCRPermission.Tracking,
                      FMCRPermission.Reports,
                      FMCRPermission.ViewTracking,
                      FMCRPermission.ViewReport,
                    ]}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<FMCR />} />
                <Route path="fleet-monitoring" element={<FMCR />} />
                <Route
                  path="vehicle-status"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.fmcr}
                      subModule={FMCRSubModules.FMCR}
                      permission="any"
                    >
                      <VehicleStatus />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="vehicle-tracking"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.fmcr}
                      subModule={FMCRSubModules.FMCR}
                      permission="any"
                    >
                      <VehicleTracking />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="vehicle_tracking"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.fmcr}
                      subModule={FMCRSubModules.FMCR}
                      permission="any"
                    >
                      <VehicleTracking />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="generate-new-report"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.fmcr}
                      subModule={FMCRSubModules.FMCR}
                      permission={FMCRPermission.CreateReport}
                    >
                      <GenerateReport />
                    </FullProtectedRoutes>
                  }
                />
                <Route
                  path="report-details/:id"
                  element={
                    <FullProtectedRoutes
                      mainModule={AppMainModules.fmcr}
                      subModule={FMCRSubModules.FMCR}
                      permission={FMCRPermission.ViewReport}
                    >
                      <ReportDetails />
                    </FullProtectedRoutes>
                  }
                />
              </Route>

              {/* =========================== */}

              <Route
                path="/fuel"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.fuelManagement}
                    subModule={FuelSubModules.Fuel}
                    permission={FuelPermission.View}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<Fuel />} />
              </Route>

              <Route
                path="/fuel/:id"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.fuelManagement}
                    subModule={FuelSubModules.Fuel}
                    permission={FuelPermission.View}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<FuelDetails />} />
              </Route>

              <Route
                path="/fuel/vehicle/:id"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.fuelManagement}
                    subModule={FuelSubModules.Fuel}
                    permission={FuelPermission.View}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<VehicleDetails />} />
              </Route>

              <Route
                path="/fuel-stations"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.fuelManagement}
                    subModule={FuelSubModules.FuelStations}
                    permission={FuelStationPermission.View}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<FuelStations />} />
              </Route>
              <Route
                path="/fuel-stations/create"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.fuelManagement}
                    subModule={FuelSubModules.FuelStations}
                    permission={FuelStationPermission.Create}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<FuelStationCreate />} />
              </Route>
              <Route
                path="/fuel-stations/details/:id"
                element={
                  <FullProtectedRoutes
                    mainModule={AppMainModules.fuelManagement}
                    subModule={FuelSubModules.FuelStations}
                    permission={FuelStationPermission.View}
                  >
                    <MainLayout />
                  </FullProtectedRoutes>
                }
              >
                <Route index element={<FuelStationDetails />} />
              </Route>

              <Route path="/test" element={<Test />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </Provider>
      </SocketProvider>
    </TripSocketProvider>
  );
};

export default App;
